import { render, staticRenderFns } from "./60rmfdgc.vue?vue&type=template&id=5d554a48&"
import script from "./60rmfdgc.vue?vue&type=script&lang=js&"
export * from "./60rmfdgc.vue?vue&type=script&lang=js&"
import style0 from "./60rmfdgc.vue?vue&type=style&index=0&id=5d554a48&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports